import type { RouteMode } from "../../router";
import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isFruitShopPath(pathname = currentPathname()): boolean {
  return isPlatformGamePath("fruit-shop", pathname);
}

export function resolveFruitShopRouteMode(
  pathname = currentPathname(),
): RouteMode {
  return isFruitShopPath(pathname) ? "v2" : "legacy";
}

export function resolveFruitShopGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isFruitShopPath(pathname) ? "game-platform" : "legacy";
}
